import React from 'react'
import styles from './video-modal.module.css'

class videoModal extends React.Component {
    constructor() {
        super()
    }
    render() {
        return (
            <div className={styles.root}>
                <a
                    className={styles.btnClose}
                    onClick={() => {
                        this.props.onClose()
                    }}
                    href="javascript:void(0)"
                />
                <video 
                src={this.props.videoUrl} 
                className={styles.video} 
                controls="controls"
                autoPlay = "true"
                disablePictureInPicture = "true"
                controlslist="nodownload nofullscreen noremoteplayback"
                onContextMenu = {(e)=>{e.preventDefault()}}
                >
                    您的浏览器不支持 video 标签。
                </video>
            </div>
        )
    }
}

export default videoModal
